import { Locale } from "./locale"

export const removeLocaleFromUri = (uri) => {
  const link = uri.replace(/\/\s*$/, "")
  return (link + "/").replace(
    new RegExp(`^/(${Locale.getSiteLocalesRegex()})`),
    "",
  )
}
